import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';

import Screen from './screen';

// import LoadingPage from 'common/LoadingPage';
import { useAsync } from 'hooks/useAsync';
import { getRedirectService } from 'services/redirect';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [, , resetRedirectState] = useAsync(getRedirectService, {
    callOnFirst: true,
    callOnFirstArgs: [{ path: pathname }],
    onSuccess: (res) => (res?.typeTrans === 'Internal'
      ? navigate({ pathname: res.to }, { replace: true, state: { redirect: true } })
      : window.location.assign(res.to)),
  });

  useEffect(() => () => {
    resetRedirectState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
        <meta name="render:status_code" content="404" />
      </Helmet>
      <div className="p-notfound">
        <Screen />
      </div>
    </>
  );
};

export default NotFound;
